import { Icon as BlueIcon } from '@blueprintjs/core';

import {
  UpdateStatusPriority,
  UpdateStatusType,
} from '@models/UpdateStatus.model';

import { getUpdateFlagColor } from '@utils/index';

import { FlagContainer, FlagLabel, Row } from './Details.styles';
import {
  IDetailsFormData,
  IDetails,
  IDetailsDisabledMap,
  UpdateNeeded,
} from './types';

export const options = [
  {
    value: UpdateStatusPriority.URGENT,
    label: (
      <Row>
        <FlagContainer>
          <BlueIcon
            icon="flag"
            color={getUpdateFlagColor(UpdateStatusPriority.URGENT)}
          />
        </FlagContainer>
        <FlagLabel>Urgent</FlagLabel>
      </Row>
    ),
  },
  {
    value: UpdateStatusPriority.IMPORTANT,
    label: (
      <Row>
        <FlagContainer>
          <BlueIcon
            icon="flag"
            color={getUpdateFlagColor(UpdateStatusPriority.IMPORTANT)}
          />
        </FlagContainer>
        <FlagLabel>Important</FlagLabel>
      </Row>
    ),
  },
  {
    value: UpdateStatusPriority.NONCRITICAL,
    label: (
      <Row>
        <FlagContainer>
          <BlueIcon
            icon="flag"
            color={getUpdateFlagColor(UpdateStatusPriority.NONCRITICAL)}
          />
        </FlagContainer>
        <FlagLabel>Non-critical</FlagLabel>
      </Row>
    ),
  },
  {
    value: UpdateStatusPriority.UNCERTAIN,
    label: (
      <Row>
        <FlagContainer>
          <BlueIcon
            icon="flag"
            color={getUpdateFlagColor(UpdateStatusPriority.UNCERTAIN)}
          />
        </FlagContainer>
        <FlagLabel>Uncertain</FlagLabel>
      </Row>
    ),
  },
  {
    value: UpdateStatusType.NEW,
    label: (
      <Row>
        <FlagContainer>
          <BlueIcon icon="record" color="#C1C4D6" />
        </FlagContainer>
        <FlagLabel>New</FlagLabel>
      </Row>
    ),
  },
];

export function createDefaultDetails(
  update?: UpdateNeeded | undefined,
): IDetailsFormData {
  const details: IDetailsFormData = {
    title: update?.subject ?? '',
    description: update?.description ?? '',
    priority: null,
    date: update?.date ?? null,
    originalMessage: update?.message ?? '',
  };

  if (update?.priority) {
    details.priority = update.priority;
  }
  if (update?.usType === UpdateStatusType.NEW) {
    details.priority = UpdateStatusType.NEW;
  }

  return details;
}
export function getEnabledMap(mode: IDetails['mode']): IDetailsDisabledMap {
  const map: IDetailsDisabledMap = new Map();

  const enabledInsights = [
    'title',
    'description',
    'date',
    'originalMessage',
  ] as const;

  const enabledBeamOn = [...enabledInsights, 'assignee', 'priority'] as const;
  if (mode === 'editing.insights') {
    enabledInsights.forEach(value => map.set(value, true));
    return map;
  }

  enabledBeamOn.forEach(value => map.set(value, true));
  return map;
}
export function getDateLabel(mode: IDetails['mode']) {
  if (mode === 'editing.insights') return 'Sent Date';
  return 'Due Date';
}
